import { render, staticRenderFns } from "./MainJouFilterCard.vue?vue&type=template&id=3983abb8&scoped=true&"
import script from "./MainJouFilterCard.vue?vue&type=script&lang=js&"
export * from "./MainJouFilterCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouFilterCard.vue?vue&type=style&index=0&id=3983abb8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983abb8",
  null
  
)

export default component.exports